import type { ApiKeyDataAPI } from './Definitions/APITypes';
import type { ApiKeyContent } from './Definitions/Types';

export const apiKeyTransformer = (response: ApiKeyDataAPI): ApiKeyContent[] => {
  return response.api_keys.map((apiKey) => ({
    createdAt: apiKey.created_at,
    keyName: apiKey.key_name,
    userEmail: apiKey.user_email,
    keyPrefix: apiKey.key_prefix,
    lastUsedAt: apiKey.last_used_at,
    userId: apiKey.user_id,
    userActive: apiKey.user_active,
  }));
};

export default apiKeyTransformer;
